// @flow
import WebComponent from '../webComponents/WebComponent';

export default class RedirectToUrl extends WebComponent {
  constructor(props) {
    super(props);
    this.timer = null;
    this.stopTimer = this.stopTimer.bind(this);
    this.startTimer = this.startTimer.bind(this);
  }

  didMount() {
    this.startTimer();

    window.addEventListener('confirmPopupShow', this.stopTimer);
    window.addEventListener('confirmPopupHide', this.startTimer);
  }

  willUnMount() {
    this.stopTimer();
    this.timer = null;
  }

  startTimer() {
    const {
      url,
      timeout,
    } = this.props;

    this.timer = setTimeout(() => {
      window.location.href = url;
    }, timeout);
  }

  stopTimer() {
    clearTimeout(this.timer);
  }
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/RedirectToUrl.js